import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { api, BridgeConfig, UpdateConfigDto } from '@/lib/api'
import toast from 'react-hot-toast'

export function useAdminConfig() {
  const queryClient = useQueryClient()

  const { data: config, isLoading, error, refetch } = useQuery<BridgeConfig>({
    queryKey: ['adminConfig'],
    queryFn: () => api.getAdminConfig(),
    retry: 1,
    staleTime: 30000,
  })

  const updateMutation = useMutation({
    mutationFn: (data: UpdateConfigDto) => {
      console.log('Updating config with:', data)
      return api.updateAdminConfig(data)
    },
    onSuccess: (updatedConfig) => {
      console.log('Config updated successfully:', updatedConfig)
      queryClient.setQueryData(['adminConfig'], updatedConfig)
      // Also invalidate the public bridge config so user page gets updated
      queryClient.invalidateQueries({ queryKey: ['bridgeConfig'] })
      toast.success('Configuración guardada')
    },
    onError: (error: Error) => {
      console.error('Error updating config:', error)
      toast.error(error.message || 'Error al guardar configuración')
    },
  })

  return {
    config,
    isLoading,
    error,
    refetch,
    updateConfig: updateMutation.mutate,
    isUpdating: updateMutation.isPending,
  }
}
